import { useRef, useEffect, useState } from 'react'
import Logo from '../../assets/images/supunnisalalogo.png';
import ProfileLogo from '../../assets/images/profilepic.png'
import './Home.scss';
import ScrollDown from '../../components/ScrollDown/ScrollDown';
import SocialMediaLinks from '../../components/SocialMediiaLinks/SocialMediaLinks';
import HorizontalTimeline from '../../components/HorizontalTimeline/Slider'
import DesktopSetup from '../../assets/images/Desktopsetup.jpg'
import PortfolioBtn from '../../components/PortfolioBtn/PortfolioBtn';
import ContactForm from '../../components/ContactForm/ContactForm';
import Footer from '../../lib/footer/Footer';
import Header from '../../lib/header/Header';

function Home() {

    const myRef = useRef();
    const [myElementIsVisible, setMyElementIsVisible] = useState(false);
    
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            console.log("entry ", entry.isIntersecting);
            setMyElementIsVisible(entry.isIntersecting);
        })
        observer.observe(myRef.current);
    },[])

    return (
        <div className='container mx-auto'>
            <div ref={myRef} id='supunnisala' className='flex flex-col h-screen items-center justify-center'>
                <img src={Logo} alt="supunnisalalg" className='logo' ></img>
                <div className='flex flex-col items-center'>
                    <h2 className='text-3xl md:text-5xl lg:text-6xl font-bold font-Marisa tracking-widepro uppercase'>Supun Nisala</h2>
                    <p className='text-xs md:text-lg lg:text-2xl font-medium uppercase tracking-widepro md:tracking-widepromax lg:tracking-widepromax'>developer | gamer | designer</p>
                </div>
                <div>
                    <ScrollDown />
                </div>
            </div>
            <div>
                <Header headerIsVisible={!myElementIsVisible} />
            </div>
            <div className='flex flex-row aboutwrapper items-center justify-center mt-0' id='about'>
                <img src={ProfileLogo} alt='Profile' className='profilepic'></img>
                <div className='flex flex-col mt-5 ' >
                    <h3  className='text-3xl md:text-4xl lg:text-5xl font-bold font-Marisa tracking-widepro uppercase text-center' >about me</h3>
                    <p  className='font-Arial aboutContent text-lg md:text-xl font-regular break-words mt-1 md:mt-3 text-center p-3'>Programmer, designer, photograper, traveler. Working at the sweet spot between beauty and elegance to answer design problems with honest solutions. I prefer clear logic to decoration.</p>
                    <div>
                        <SocialMediaLinks />
                    </div>
                </div>
            </div>
            <div id='lifeExperience' className='mt-20 container'>
                <h3 className='text-3xl md:text-4xl lg:text-5xl font-bold font-Marisa tracking-widepro uppercase text-center mb-10' >Life Experience</h3>
                <HorizontalTimeline />
            </div>
            <div>
            <div className="flex justify-center portfolio mt-10 md:mt-20">
            <div className="flex flex-col justify-center xl:mr-2 mx-5">
                <div>
                    <h3 id="portfolio" className="font-Marisa text-3xl md:text-4xl lg:text-5xl font-bold tracking-wide uppercase text-center">
                        Portfolio
                    </h3>   
                </div>
                <div className='portfolioContent'>
                    <p className="font-Arial mx-auto text-lg md:text-xl font-regular text-justify break-words mt-5">
                        Hello! I'm Supun Gunasekara, a passionate and versatile Software Engineer with a diverse set of skills and a strong foundation in both front-end and back-end development.
                        I have a robust experience in building responsive and dynamic user interfaces using modern frontend frameworks such as ReactJS, Phoenix, and AngularJS. My proficiency in these technologies enables me to create seamless and intuitive user experiences that are both visually appealing and highly functional.
                        <br/><br/>
                        My backend development skills are equally strong, with a deep understanding of frameworks like .Net, .Net Core, Spring Boot, NestJS, and ExpressJS. I am adept at designing and implementing scalable, secure, and efficient server-side applications that power complex web systems.
                        I am proficient in multiple programming languages including Java, C#, JavaScript, Python, and Elixir. This versatility allows me to choose the best language for the task at hand, ensuring optimal performance and maintainability of the codebase.
                        <br/><br/>
                        My experience with databases spans across MySQL, MS SQL, and Firebase. I am skilled in database design, optimization, and management, ensuring data integrity and efficiency in all my projects.
                        I am well-versed in version control systems such as GIT, GitLab, and GitHub. These tools are essential for managing code changes and collaborating effectively with other developers, ensuring smooth project progression and code quality.
                        <br/><br/>
                        In addition to my core development skills, I have experience with Tailwind CSS for styling, Conda environment for package management, and ASDF for managing multiple runtime versions. My proficiency in JIRA helps me manage projects efficiently, track progress, and collaborate with team members.
                    </p>
                </div>
                <div className='flex flex-col md:flex-col lg:flex-row justify-between portfolioContent'>
                    <div className='flex flex-col lg:pr-3'>
                        <p className="font-Arial text-lg md:text-xl font-regular text-justify break-words mx-auto mt-0">
                            Beyond coding, I have a strong background in design. I am skilled in using Figma for UI/UX design, and I am proficient with Adobe software including Photoshop, After Effects, Illustrator, and Premiere Pro. This combination of development and design skills allows me to create cohesive and visually stunning digital experiences.
                            <br/><br/>
                            Thank you for visiting my portfolio. I am always excited to connect with like-minded professionals and explore new opportunities. Feel free to browse through my projects and get in touch if you have any questions or would like to collaborate on a project.
                        </p>
                        <PortfolioBtn />
                    </div>
                    <div className="flex justify-center w-100">
                        <img src={DesktopSetup} alt="Desktop_Setup" className="DesktopSetup" />
                    </div> 
                </div>
            </div>
                       
            </div>
            </div>
            <div id='contact' >
                <ContactForm />
            </div>
            <Footer />
        </div>
    );
}

export default Home; 